import { Navigate, useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { useEffect, useState } from "react";
import { userInfoSelector } from "../states/user";

export const PrivateRoute = () => {
  const userInfo = useRecoilValue(userInfoSelector);

  if (!userInfo) {
    return <Navigate to="/sign-in" />;
  }

  if (userInfo?.state !== "APPROVED") {
    return <Navigate to="/pending" />;
  }

  return <Navigate to="/home" />;
};
